import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-163fdf4b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid m-0 h-full bg-white" }
const _hoisted_2 = { class: "col-4 th pb-0" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "顧客メモ  ", -1))
const _hoisted_4 = {
  key: 0,
  class: "col-8 td pb-0"
}
const _hoisted_5 = {
  id: "text-error",
  class: "p-error"
}
const _hoisted_6 = { class: "dialog-footer grid mt-3" }
const _hoisted_7 = { class: "col-6 flex justify-content-center p-0" }
const _hoisted_8 = { class: "col-6 flex justify-content-center p-0" }

import EditableTextarea from "@/clinic/components/atoms/EditableTexarea/index.vue";
import { onBeforeMount, ref, watch, computed } from "vue";
import { ApiEditNoteReq, ApiListNoteReq, ApiSaveNoteReq, ApiTrashNoteReq } from "@/clinic/typings";
import { useToast } from "primevue/usetoast";
import { NoteServices } from "@/clinic/services";
import { get, set } from "@vueuse/core";
import { notifySuccessMsg, notityErrorMsg } from "@/clinic/utils/notify-utils";
import { useConfirm } from "primevue/useconfirm";
import { CALCULATOR_HEIGHT_CUSTOMER_NOTE } from "@/clinic/typings/constants/clinic";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerNote',
  props: {
    clinicId: null,
    customerId: null,
    headerProfileHeight: null,
    messageContainerHeight: null,
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  clinicId: number;
  customerId: number;
  headerProfileHeight: number;
  messageContainerHeight: number;
  disabled: boolean;
};



const notes = ref();
const visible = ref<boolean>(false);
const noteVal = ref<string>("");
const errorMessage = ref<string>("");
const confirm = useConfirm();
const toast = useToast();
let isEditNote = ref<boolean>(false);
const noteId = ref();

const validateNote = () => {
  errorMessage.value = "";
  if (noteVal.value.trim() == "") {
    errorMessage.value = "メモを入力してください。";
    return;
  }
  if (noteVal.value.length > 300) {
    errorMessage.value = "300文字以下にしてください。";
    return;
  }
};

const onClosedDialog = () => {
  set(visible, false);
  set(noteVal, "");
  set(errorMessage, "");
  set(isEditNote, false);
};

const onShowDialog = async (id: number, content: string) => {
  set(noteId, get(id));
  set(noteVal, get(content));
  set(visible, true);
  set(isEditNote, true);
};

const handleApiResponse = async (params: any, isEdit: boolean) => {
  const successCallback = () => notifySuccessMsg(toast, "成功");
  const errorCallback = () => notityErrorMsg(toast, "エラー");

  if (isEdit) {
    await NoteServices.editNote(params, successCallback, errorCallback);
  } else {
    await NoteServices.saveNote(params, successCallback, errorCallback);
  }
};

const onSaveNote = async () => {
  validateNote();
  if (errorMessage.value === "") {
    const commonParams = {
      customer_id: props.customerId,
      clinic_id: props.clinicId,
      content: get(noteVal),
    };

    let params;
    const isEdit = get(isEditNote);

    if (isEdit) {
      params = { ...commonParams, id: get(noteId) } as ApiEditNoteReq;
    } else {
      params = { ...commonParams } as ApiSaveNoteReq;
    }

    await handleApiResponse(params, isEdit);

    set(isEditNote, false);
    set(visible, false);
    set(noteVal, "");

    await listNotes();
  }
};

const trashNote = async (noteId: number) => {
  confirm.require({
    message: "顧客メモを削除します。よろしいですか？",
    header: "注意",
    rejectLabel: "キャンセル",
    acceptLabel: "OK",
    acceptClass: "p-button-danger",
    accept: async () => {
      const params = {
        id: noteId,
        customer_id: props.customerId,
        clinic_id: props.clinicId,
      } as ApiTrashNoteReq;
      await NoteServices.trashNote(
        params,
        () => notifySuccessMsg(toast, "成功"),
        () => notityErrorMsg(toast, "エラー")
      );
      await listNotes();
    },
  });
};

const listNotes = async () => {
  const { data } = await NoteServices.listNotes({
    customer_id: props.customerId,
    clinic_id: props.clinicId,
  } as ApiListNoteReq);
  set(notes, get(data));
};

const maxHeightStyle = computed(() => {
  const maxHeight = `calc(${props.messageContainerHeight}px - ${
    props.headerProfileHeight + CALCULATOR_HEIGHT_CUSTOMER_NOTE
  }px)`;
  return { "max-height": maxHeight };
});

onBeforeMount(async () => {
  await listNotes();
});

watch(
  () => props.customerId,
  () => {
    listNotes();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (!props.disabled)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: "pi pi-pencil icon-pi-pencil-orange cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = true))
            }))
          : _createCommentVNode("", true)
      ]),
      (notes.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "mt-2 note-container",
              style: _normalizeStyle(_unref(maxHeightStyle))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notes.value, (note) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: note.id,
                  class: "mt-3"
                }, [
                  _createVNode(EditableTextarea, {
                    "customer-id": props.customerId,
                    "note-id": note.id || 0,
                    content: note.content || '',
                    created: note.created_at,
                    "clinic-id": props.clinicId,
                    disabled: props.disabled,
                    onTrash: trashNote,
                    onShow: onShowDialog
                  }, null, 8, ["customer-id", "note-id", "content", "created", "clinic-id", "disabled"])
                ]))
              }), 128))
            ], 4)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Dialog, {
      visible: visible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
      modal: "",
      header: '顧客メモを追加',
      style: { width: '550px' },
      class: "mx-5 dialog-note border-0",
      draggable: false,
      onHide: onClosedDialog
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Textarea, {
          modelValue: noteVal.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((noteVal).value = $event)),
          "aria-describedby": "description-help",
          type: "text",
          size: "large",
          name: "note",
          rows: "10",
          cols: "30",
          class: _normalizeClass(["textarea-note", { 'p-invalid': errorMessage.value }]),
          placeholder: "顧客の情報を追加できます。メモの情報は相手には公開されません。"
        }, null, 8, ["modelValue", "class"]),
        _createElementVNode("small", _hoisted_5, _toDisplayString(errorMessage.value || " "), 1),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Button, {
              label: "キャンセル",
              class: "p-button-light w-100",
              onClick: onClosedDialog
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Button, {
              class: "w-100",
              label: "保存",
              onClick: onSaveNote
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Toast, { position: "top-center" })
  ], 64))
}
}

})